import { NichoEstabelecimentoEnum } from '../enum/bardo/nicho-estabelecimento.enum';

export interface ITermoItem {
  singular: string;
  plural: string;
  genero: 'M' | 'F';
  placeholderBusca: string;
  placeholderNovo: string;
  placeholderSelecione: string;
}

export interface INichoTermos {
  nichoId: NichoEstabelecimentoEnum;
  nichoNome: string;
  cliente: ITermoItem;
  profissional: ITermoItem;
  servico: ITermoItem;
  agendamento: {
    singular: string;
    plural: string;
    btnNovo: string;
    modalTituloNovo: string;
    confirmacaoCancelamento: string;
  };
}

/** Dicionário em Português (pt-BR) */
export const NICHO_TERMOS_PT: Record<NichoEstabelecimentoEnum, INichoTermos> = {
  [NichoEstabelecimentoEnum.BELEZA_ESTETICA]: {
    nichoId: NichoEstabelecimentoEnum.BELEZA_ESTETICA,
    nichoNome: 'Beleza & Estética',
    cliente: {
      singular: 'Cliente',
      plural: 'Clientes',
      genero: 'M',
      placeholderBusca: 'Buscar cliente por nome ou celular...',
      placeholderNovo: 'Nome do cliente',
      placeholderSelecione: 'Selecione o cliente',
    },
    profissional: {
      singular: 'Profissional',
      plural: 'Profissionais',
      genero: 'M',
      placeholderBusca: 'Buscar profissional...',
      placeholderNovo: 'Nome do profissional',
      placeholderSelecione: 'Selecione o profissional',
    },
    servico: {
      singular: 'Serviço',
      plural: 'Serviços',
      genero: 'M',
      placeholderBusca: 'Buscar serviço...',
      placeholderNovo: 'Nome do serviço',
      placeholderSelecione: 'Selecione o serviço',
    },
    agendamento: {
      singular: 'Agendamento',
      plural: 'Agendamentos',
      btnNovo: 'Novo Agendamento',
      modalTituloNovo: 'Novo Agendamento',
      confirmacaoCancelamento: 'Deseja realmente cancelar este agendamento?',
    },
  },
  [NichoEstabelecimentoEnum.SAUDE_BEM_ESTAR]: {
    nichoId: NichoEstabelecimentoEnum.SAUDE_BEM_ESTAR,
    nichoNome: 'Saúde & Bem-Estar',
    cliente: {
      singular: 'Paciente',
      plural: 'Pacientes',
      genero: 'M',
      placeholderBusca: 'Buscar paciente por nome ou CPF...',
      placeholderNovo: 'Nome do paciente',
      placeholderSelecione: 'Selecione o paciente',
    },
    profissional: {
      singular: 'Especialista',
      plural: 'Especialistas',
      genero: 'M',
      placeholderBusca: 'Buscar médico ou especialista...',
      placeholderNovo: 'Nome do médico / especialista',
      placeholderSelecione: 'Selecione o médico / especialista',
    },
    servico: {
      singular: 'Consulta / Procedimento',
      plural: 'Consultas e Procedimentos',
      genero: 'F',
      placeholderBusca: 'Buscar consulta ou procedimento...',
      placeholderNovo: 'Nome da consulta / procedimento',
      placeholderSelecione: 'Selecione a consulta / procedimento',
    },
    agendamento: {
      singular: 'Consulta',
      plural: 'Consultas',
      btnNovo: 'Nova Consulta',
      modalTituloNovo: 'Agendar Consulta',
      confirmacaoCancelamento: 'Deseja realmente cancelar esta consulta?',
    },
  },
  [NichoEstabelecimentoEnum.FITNESS_ESPORTES]: {
    nichoId: NichoEstabelecimentoEnum.FITNESS_ESPORTES,
    nichoNome: 'Fitness & Studios',
    cliente: {
      singular: 'Aluno',
      plural: 'Alunos',
      genero: 'M',
      placeholderBusca: 'Buscar aluno por nome...',
      placeholderNovo: 'Nome do aluno',
      placeholderSelecione: 'Selecione o aluno',
    },
    profissional: {
      singular: 'Instrutor / Personal',
      plural: 'Instrutores & Personais',
      genero: 'M',
      placeholderBusca: 'Buscar instrutor...',
      placeholderNovo: 'Nome do instrutor / personal',
      placeholderSelecione: 'Selecione o instrutor / personal',
    },
    servico: {
      singular: 'Aula / Treino',
      plural: 'Aulas e Treinos',
      genero: 'F',
      placeholderBusca: 'Buscar aula ou modalidade...',
      placeholderNovo: 'Nome da aula / modalidade',
      placeholderSelecione: 'Selecione a aula / modalidade',
    },
    agendamento: {
      singular: 'Aula',
      plural: 'Aulas',
      btnNovo: 'Agendar Aula',
      modalTituloNovo: 'Agendar Nova Aula',
      confirmacaoCancelamento: 'Deseja realmente cancelar este agendamento de aula?',
    },
  },
  [NichoEstabelecimentoEnum.PET_CARE]: {
    nichoId: NichoEstabelecimentoEnum.PET_CARE,
    nichoNome: 'Pet & Veterinária',
    cliente: {
      singular: 'Tutor (Pet)',
      plural: 'Tutores & Pets',
      genero: 'M',
      placeholderBusca: 'Buscar tutor ou nome do pet...',
      placeholderNovo: 'Nome do tutor / pet',
      placeholderSelecione: 'Selecione o tutor / pet',
    },
    profissional: {
      singular: 'Veterinário / Atendente',
      plural: 'Veterinários & Atendentes',
      genero: 'M',
      placeholderBusca: 'Buscar veterinário ou tosador...',
      placeholderNovo: 'Nome do veterinário / tosador',
      placeholderSelecione: 'Selecione o veterinário / tosador',
    },
    servico: {
      singular: 'Banho & Tosa / Consulta',
      plural: 'Banhos & Consultas',
      genero: 'M',
      placeholderBusca: 'Buscar serviço pet...',
      placeholderNovo: 'Nome do serviço pet',
      placeholderSelecione: 'Selecione o serviço pet',
    },
    agendamento: {
      singular: 'Atendimento',
      plural: 'Atendimentos',
      btnNovo: 'Novo Atendimento Pet',
      modalTituloNovo: 'Agendar Atendimento Pet',
      confirmacaoCancelamento: 'Deseja realmente cancelar este atendimento pet?',
    },
  },
  [NichoEstabelecimentoEnum.CONSULTORIA_SERVICOS]: {
    nichoId: NichoEstabelecimentoEnum.CONSULTORIA_SERVICOS,
    nichoNome: 'Consultoria & Serviços',
    cliente: {
      singular: 'Cliente',
      plural: 'Clientes',
      genero: 'M',
      placeholderBusca: 'Buscar cliente...',
      placeholderNovo: 'Nome do cliente',
      placeholderSelecione: 'Selecione o cliente',
    },
    profissional: {
      singular: 'Consultor / Advogado',
      plural: 'Consultores & Advogados',
      genero: 'M',
      placeholderBusca: 'Buscar consultor...',
      placeholderNovo: 'Nome do consultor / advogado',
      placeholderSelecione: 'Selecione o consultor / advogado',
    },
    servico: {
      singular: 'Consultoria / Reunião',
      plural: 'Consultorias & Reuniões',
      genero: 'F',
      placeholderBusca: 'Buscar tipo de consultoria...',
      placeholderNovo: 'Assunto / Tipo de consultoria',
      placeholderSelecione: 'Selecione o tipo de consultoria',
    },
    agendamento: {
      singular: 'Reunião',
      plural: 'Reuniões',
      btnNovo: 'Agendar Reunião',
      modalTituloNovo: 'Agendar Nova Reunião',
      confirmacaoCancelamento: 'Deseja realmente cancelar esta reunião?',
    },
  },
  [NichoEstabelecimentoEnum.ESTUDIO_ARTE]: {
    nichoId: NichoEstabelecimentoEnum.ESTUDIO_ARTE,
    nichoNome: 'Arte & Estúdio',
    cliente: {
      singular: 'Cliente',
      plural: 'Clientes',
      genero: 'M',
      placeholderBusca: 'Buscar cliente...',
      placeholderNovo: 'Nome do cliente',
      placeholderSelecione: 'Selecione o cliente',
    },
    profissional: {
      singular: 'Artista / Tatuador',
      plural: 'Artistas & Tatuadores',
      genero: 'M',
      placeholderBusca: 'Buscar artista ou tatuador...',
      placeholderNovo: 'Nome do artista / tatuador',
      placeholderSelecione: 'Selecione o artista / tatuador',
    },
    servico: {
      singular: 'Sessão / Ensaio',
      plural: 'Sessões & Ensaios',
      genero: 'F',
      placeholderBusca: 'Buscar tipo de sessão...',
      placeholderNovo: 'Nome da sessão / ensaio',
      placeholderSelecione: 'Selecione a sessão / ensaio',
    },
    agendamento: {
      singular: 'Sessão',
      plural: 'Sessões',
      btnNovo: 'Agendar Sessão',
      modalTituloNovo: 'Agendar Nova Sessão',
      confirmacaoCancelamento: 'Deseja realmente cancelar esta sessão?',
    },
  },
  [NichoEstabelecimentoEnum.SERVICOS_TECNICOS]: {
    nichoId: NichoEstabelecimentoEnum.SERVICOS_TECNICOS,
    nichoNome: 'Serviços Técnicos & Manutenção',
    cliente: {
      singular: 'Cliente',
      plural: 'Clientes',
      genero: 'M',
      placeholderBusca: 'Buscar cliente por nome ou celular...',
      placeholderNovo: 'Nome do cliente',
      placeholderSelecione: 'Selecione o cliente',
    },
    profissional: {
      singular: 'Técnico',
      plural: 'Técnicos',
      genero: 'M',
      placeholderBusca: 'Buscar técnico ou prestador...',
      placeholderNovo: 'Nome do técnico',
      placeholderSelecione: 'Selecione o técnico',
    },
    servico: {
      singular: 'Serviço',
      plural: 'Serviços',
      genero: 'M',
      placeholderBusca: 'Buscar serviço ou tipo de visita...',
      placeholderNovo: 'Nome do serviço (ex: pintura, instalação)',
      placeholderSelecione: 'Selecione o serviço',
    },
    agendamento: {
      singular: 'Visita',
      plural: 'Visitas',
      btnNovo: 'Nova Visita',
      modalTituloNovo: 'Agendar Visita',
      confirmacaoCancelamento: 'Deseja realmente cancelar esta visita?',
    },
  },
  [NichoEstabelecimentoEnum.INFORMATICA]: {
    nichoId: NichoEstabelecimentoEnum.INFORMATICA,
    nichoNome: 'Informática & Assistência Técnica',
    cliente: {
      singular: 'Cliente',
      plural: 'Clientes',
      genero: 'M',
      placeholderBusca: 'Buscar cliente por nome ou celular...',
      placeholderNovo: 'Nome do cliente',
      placeholderSelecione: 'Selecione o cliente',
    },
    profissional: {
      singular: 'Técnico',
      plural: 'Técnicos',
      genero: 'M',
      placeholderBusca: 'Buscar técnico...',
      placeholderNovo: 'Nome do técnico',
      placeholderSelecione: 'Selecione o técnico',
    },
    servico: {
      singular: 'Serviço / Reparo',
      plural: 'Serviços e Reparos',
      genero: 'M',
      placeholderBusca: 'Buscar serviço ou tipo de reparo...',
      placeholderNovo: 'Nome do serviço (ex: formatação, troca de tela)',
      placeholderSelecione: 'Selecione o serviço',
    },
    agendamento: {
      singular: 'Atendimento',
      plural: 'Atendimentos',
      btnNovo: 'Novo Atendimento',
      modalTituloNovo: 'Agendar Atendimento',
      confirmacaoCancelamento: 'Deseja realmente cancelar este atendimento?',
    },
  },
  [NichoEstabelecimentoEnum.AUTOMOTIVO]: {
    nichoId: NichoEstabelecimentoEnum.AUTOMOTIVO,
    nichoNome: 'Oficina Automotiva',
    cliente: {
      singular: 'Cliente',
      plural: 'Clientes',
      genero: 'M',
      placeholderBusca: 'Buscar cliente por nome ou placa...',
      placeholderNovo: 'Nome do cliente',
      placeholderSelecione: 'Selecione o cliente',
    },
    profissional: {
      singular: 'Mecânico',
      plural: 'Mecânicos',
      genero: 'M',
      placeholderBusca: 'Buscar mecânico...',
      placeholderNovo: 'Nome do mecânico',
      placeholderSelecione: 'Selecione o mecânico',
    },
    servico: {
      singular: 'Serviço',
      plural: 'Serviços',
      genero: 'M',
      placeholderBusca: 'Buscar serviço (revisão, alinhamento...)',
      placeholderNovo: 'Nome do serviço (ex: revisão, troca de óleo)',
      placeholderSelecione: 'Selecione o serviço',
    },
    agendamento: {
      singular: 'Ordem de Serviço',
      plural: 'Ordens de Serviço',
      btnNovo: 'Nova OS',
      modalTituloNovo: 'Nova Ordem de Serviço',
      confirmacaoCancelamento: 'Deseja realmente cancelar esta ordem de serviço?',
    },
  },
};

/** Dicionário em Inglês (en-US) */
export const NICHO_TERMOS_EN: Record<NichoEstabelecimentoEnum, INichoTermos> = {
  [NichoEstabelecimentoEnum.BELEZA_ESTETICA]: {
    nichoId: NichoEstabelecimentoEnum.BELEZA_ESTETICA,
    nichoNome: 'Beauty & Aesthetics',
    cliente: {
      singular: 'Client',
      plural: 'Clients',
      genero: 'M',
      placeholderBusca: 'Search client by name or phone...',
      placeholderNovo: 'Client name',
      placeholderSelecione: 'Select client',
    },
    profissional: {
      singular: 'Professional',
      plural: 'Professionals',
      genero: 'M',
      placeholderBusca: 'Search professional...',
      placeholderNovo: 'Professional name',
      placeholderSelecione: 'Select professional',
    },
    servico: {
      singular: 'Service',
      plural: 'Services',
      genero: 'M',
      placeholderBusca: 'Search service...',
      placeholderNovo: 'Service name',
      placeholderSelecione: 'Select service',
    },
    agendamento: {
      singular: 'Appointment',
      plural: 'Appointments',
      btnNovo: 'New Appointment',
      modalTituloNovo: 'New Appointment',
      confirmacaoCancelamento: 'Do you really want to cancel this appointment?',
    },
  },
  [NichoEstabelecimentoEnum.SAUDE_BEM_ESTAR]: {
    nichoId: NichoEstabelecimentoEnum.SAUDE_BEM_ESTAR,
    nichoNome: 'Health & Wellness',
    cliente: {
      singular: 'Patient',
      plural: 'Patients',
      genero: 'M',
      placeholderBusca: 'Search patient by name or ID...',
      placeholderNovo: 'Patient name',
      placeholderSelecione: 'Select patient',
    },
    profissional: {
      singular: 'Specialist',
      plural: 'Specialists',
      genero: 'M',
      placeholderBusca: 'Search doctor or specialist...',
      placeholderNovo: 'Doctor / specialist name',
      placeholderSelecione: 'Select doctor / specialist',
    },
    servico: {
      singular: 'Consultation / Procedure',
      plural: 'Consultations and Procedures',
      genero: 'F',
      placeholderBusca: 'Search consultation or procedure...',
      placeholderNovo: 'Consultation / procedure name',
      placeholderSelecione: 'Select consultation / procedure',
    },
    agendamento: {
      singular: 'Consultation',
      plural: 'Consultations',
      btnNovo: 'New Consultation',
      modalTituloNovo: 'Book Consultation',
      confirmacaoCancelamento: 'Do you really want to cancel this consultation?',
    },
  },
  [NichoEstabelecimentoEnum.FITNESS_ESPORTES]: {
    nichoId: NichoEstabelecimentoEnum.FITNESS_ESPORTES,
    nichoNome: 'Fitness & Studios',
    cliente: {
      singular: 'Student',
      plural: 'Students',
      genero: 'M',
      placeholderBusca: 'Search student by name...',
      placeholderNovo: 'Student name',
      placeholderSelecione: 'Select student',
    },
    profissional: {
      singular: 'Instructor / Trainer',
      plural: 'Instructors & Trainers',
      genero: 'M',
      placeholderBusca: 'Search instructor...',
      placeholderNovo: 'Instructor / trainer name',
      placeholderSelecione: 'Select instructor / trainer',
    },
    servico: {
      singular: 'Class / Workout',
      plural: 'Classes and Workouts',
      genero: 'F',
      placeholderBusca: 'Search class or category...',
      placeholderNovo: 'Class / workout name',
      placeholderSelecione: 'Select class / workout',
    },
    agendamento: {
      singular: 'Class',
      plural: 'Classes',
      btnNovo: 'Book Class',
      modalTituloNovo: 'Book New Class',
      confirmacaoCancelamento: 'Do you really want to cancel this class booking?',
    },
  },
  [NichoEstabelecimentoEnum.PET_CARE]: {
    nichoId: NichoEstabelecimentoEnum.PET_CARE,
    nichoNome: 'Pet Care & Vet',
    cliente: {
      singular: 'Pet Owner',
      plural: 'Pet Owners',
      genero: 'M',
      placeholderBusca: 'Search owner or pet name...',
      placeholderNovo: 'Owner / pet name',
      placeholderSelecione: 'Select owner / pet',
    },
    profissional: {
      singular: 'Veterinarian / Groomer',
      plural: 'Veterinarians & Groomers',
      genero: 'M',
      placeholderBusca: 'Search vet or groomer...',
      placeholderNovo: 'Vet / groomer name',
      placeholderSelecione: 'Select vet / groomer',
    },
    servico: {
      singular: 'Grooming / Vet Visit',
      plural: 'Grooming & Vet Visits',
      genero: 'M',
      placeholderBusca: 'Search pet service...',
      placeholderNovo: 'Pet service name',
      placeholderSelecione: 'Select pet service',
    },
    agendamento: {
      singular: 'Appointment',
      plural: 'Appointments',
      btnNovo: 'New Pet Appointment',
      modalTituloNovo: 'Book Pet Appointment',
      confirmacaoCancelamento: 'Do you really want to cancel this pet appointment?',
    },
  },
  [NichoEstabelecimentoEnum.CONSULTORIA_SERVICOS]: {
    nichoId: NichoEstabelecimentoEnum.CONSULTORIA_SERVICOS,
    nichoNome: 'Consulting & Services',
    cliente: {
      singular: 'Client',
      plural: 'Clients',
      genero: 'M',
      placeholderBusca: 'Search client...',
      placeholderNovo: 'Client name',
      placeholderSelecione: 'Select client',
    },
    profissional: {
      singular: 'Consultant / Lawyer',
      plural: 'Consultants & Lawyers',
      genero: 'M',
      placeholderBusca: 'Search consultant...',
      placeholderNovo: 'Consultant / lawyer name',
      placeholderSelecione: 'Select consultant / lawyer',
    },
    servico: {
      singular: 'Consulting / Meeting',
      plural: 'Consultings & Meetings',
      genero: 'F',
      placeholderBusca: 'Search consulting type...',
      placeholderNovo: 'Subject / Consulting type',
      placeholderSelecione: 'Select consulting type',
    },
    agendamento: {
      singular: 'Meeting',
      plural: 'Meetings',
      btnNovo: 'Schedule Meeting',
      modalTituloNovo: 'Schedule New Meeting',
      confirmacaoCancelamento: 'Do you really want to cancel this meeting?',
    },
  },
  [NichoEstabelecimentoEnum.ESTUDIO_ARTE]: {
    nichoId: NichoEstabelecimentoEnum.ESTUDIO_ARTE,
    nichoNome: 'Art & Studio',
    cliente: {
      singular: 'Client',
      plural: 'Clients',
      genero: 'M',
      placeholderBusca: 'Search client...',
      placeholderNovo: 'Client name',
      placeholderSelecione: 'Select client',
    },
    profissional: {
      singular: 'Artist / Tattooer',
      plural: 'Artists & Tattooers',
      genero: 'M',
      placeholderBusca: 'Search artist or tattooer...',
      placeholderNovo: 'Artist / tattooer name',
      placeholderSelecione: 'Select artist / tattooer',
    },
    servico: {
      singular: 'Session / Shoot',
      plural: 'Sessions & Shoots',
      genero: 'F',
      placeholderBusca: 'Search session type...',
      placeholderNovo: 'Session / shoot name',
      placeholderSelecione: 'Select session / shoot',
    },
    agendamento: {
      singular: 'Session',
      plural: 'Sessions',
      btnNovo: 'Book Session',
      modalTituloNovo: 'Book New Session',
      confirmacaoCancelamento: 'Do you really want to cancel this session?',
    },
  },
  [NichoEstabelecimentoEnum.SERVICOS_TECNICOS]: {
    nichoId: NichoEstabelecimentoEnum.SERVICOS_TECNICOS,
    nichoNome: 'Technical Services & Maintenance',
    cliente: {
      singular: 'Client',
      plural: 'Clients',
      genero: 'M',
      placeholderBusca: 'Search client by name or phone...',
      placeholderNovo: 'Client name',
      placeholderSelecione: 'Select client',
    },
    profissional: {
      singular: 'Technician',
      plural: 'Technicians',
      genero: 'M',
      placeholderBusca: 'Search technician or provider...',
      placeholderNovo: 'Technician name',
      placeholderSelecione: 'Select technician',
    },
    servico: {
      singular: 'Service',
      plural: 'Services',
      genero: 'M',
      placeholderBusca: 'Search service or visit type...',
      placeholderNovo: 'Service name (e.g., painting, installation)',
      placeholderSelecione: 'Select service',
    },
    agendamento: {
      singular: 'Visit',
      plural: 'Visits',
      btnNovo: 'New Visit',
      modalTituloNovo: 'Schedule Visit',
      confirmacaoCancelamento: 'Do you really want to cancel this visit?',
    },
  },
  [NichoEstabelecimentoEnum.INFORMATICA]: {
    nichoId: NichoEstabelecimentoEnum.INFORMATICA,
    nichoNome: 'IT & Technical Assistance',
    cliente: {
      singular: 'Client',
      plural: 'Clients',
      genero: 'M',
      placeholderBusca: 'Search client by name or phone...',
      placeholderNovo: 'Client name',
      placeholderSelecione: 'Select client',
    },
    profissional: {
      singular: 'Technician',
      plural: 'Technicians',
      genero: 'M',
      placeholderBusca: 'Search technician...',
      placeholderNovo: 'Technician name',
      placeholderSelecione: 'Select technician',
    },
    servico: {
      singular: 'Service / Repair',
      plural: 'Services and Repairs',
      genero: 'M',
      placeholderBusca: 'Search service or repair type...',
      placeholderNovo: 'Service name (e.g., system format, screen replacement)',
      placeholderSelecione: 'Select service',
    },
    agendamento: {
      singular: 'Service Ticket',
      plural: 'Service Tickets',
      btnNovo: 'New Service Ticket',
      modalTituloNovo: 'Schedule Service Ticket',
      confirmacaoCancelamento: 'Do you really want to cancel this service ticket?',
    },
  },
  [NichoEstabelecimentoEnum.AUTOMOTIVO]: {
    nichoId: NichoEstabelecimentoEnum.AUTOMOTIVO,
    nichoNome: 'Auto Repair Shop',
    cliente: {
      singular: 'Customer',
      plural: 'Customers',
      genero: 'M',
      placeholderBusca: 'Search customer by name or license plate...',
      placeholderNovo: 'Customer name',
      placeholderSelecione: 'Select customer',
    },
    profissional: {
      singular: 'Mechanic',
      plural: 'Mechanics',
      genero: 'M',
      placeholderBusca: 'Search mechanic...',
      placeholderNovo: 'Mechanic name',
      placeholderSelecione: 'Select mechanic',
    },
    servico: {
      singular: 'Service',
      plural: 'Services',
      genero: 'M',
      placeholderBusca: 'Search service (maintenance, alignment...)',
      placeholderNovo: 'Service name (e.g., oil change, brake check)',
      placeholderSelecione: 'Select service',
    },
    agendamento: {
      singular: 'Work Order',
      plural: 'Work Orders',
      btnNovo: 'New Work Order',
      modalTituloNovo: 'New Work Order',
      confirmacaoCancelamento: 'Do you really want to cancel this work order?',
    },
  },
};

/** Dicionário em Espanhol (es-ES) */
export const NICHO_TERMOS_ES: Record<NichoEstabelecimentoEnum, INichoTermos> = {
  [NichoEstabelecimentoEnum.BELEZA_ESTETICA]: {
    nichoId: NichoEstabelecimentoEnum.BELEZA_ESTETICA,
    nichoNome: 'Belleza y Estética',
    cliente: {
      singular: 'Cliente',
      plural: 'Clientes',
      genero: 'M',
      placeholderBusca: 'Buscar cliente por nombre o móvil...',
      placeholderNovo: 'Nombre del cliente',
      placeholderSelecione: 'Seleccione el cliente',
    },
    profissional: {
      singular: 'Profesional',
      plural: 'Profesionales',
      genero: 'M',
      placeholderBusca: 'Buscar profesional...',
      placeholderNovo: 'Nombre del profesional',
      placeholderSelecione: 'Seleccione el profesional',
    },
    servico: {
      singular: 'Servicio',
      plural: 'Servicios',
      genero: 'M',
      placeholderBusca: 'Buscar servicio...',
      placeholderNovo: 'Nombre del servicio',
      placeholderSelecione: 'Seleccione el servicio',
    },
    agendamento: {
      singular: 'Cita',
      plural: 'Citas',
      btnNovo: 'Nueva Cita',
      modalTituloNovo: 'Nueva Cita',
      confirmacaoCancelamento: '¿Realmente desea cancelar esta cita?',
    },
  },
  [NichoEstabelecimentoEnum.SAUDE_BEM_ESTAR]: {
    nichoId: NichoEstabelecimentoEnum.SAUDE_BEM_ESTAR,
    nichoNome: 'Salud y Bienestar',
    cliente: {
      singular: 'Paciente',
      plural: 'Pacientes',
      genero: 'M',
      placeholderBusca: 'Buscar paciente por nombre o documento...',
      placeholderNovo: 'Nombre del paciente',
      placeholderSelecione: 'Seleccione el paciente',
    },
    profissional: {
      singular: 'Especialista',
      plural: 'Especialistas',
      genero: 'M',
      placeholderBusca: 'Buscar médico o especialista...',
      placeholderNovo: 'Nombre del médico / especialista',
      placeholderSelecione: 'Seleccione el médico / especialista',
    },
    servico: {
      singular: 'Consulta / Procedimiento',
      plural: 'Consultas y Procedimientos',
      genero: 'F',
      placeholderBusca: 'Buscar consulta o procedimiento...',
      placeholderNovo: 'Nombre de la consulta / procedimiento',
      placeholderSelecione: 'Seleccione la consulta / procedimiento',
    },
    agendamento: {
      singular: 'Consulta',
      plural: 'Consultas',
      btnNovo: 'Nueva Consulta',
      modalTituloNovo: 'Agendar Consulta',
      confirmacaoCancelamento: '¿Realmente desea cancelar esta consulta?',
    },
  },
  [NichoEstabelecimentoEnum.FITNESS_ESPORTES]: {
    nichoId: NichoEstabelecimentoEnum.FITNESS_ESPORTES,
    nichoNome: 'Fitness y Gimnasios',
    cliente: {
      singular: 'Alumno',
      plural: 'Alumnos',
      genero: 'M',
      placeholderBusca: 'Buscar alumno por nombre...',
      placeholderNovo: 'Nombre del alumno',
      placeholderSelecione: 'Seleccione el alumno',
    },
    profissional: {
      singular: 'Instructor / Entrenador',
      plural: 'Instructores y Entrenadores',
      genero: 'M',
      placeholderBusca: 'Buscar instructor...',
      placeholderNovo: 'Nombre del instructor / entrenador',
      placeholderSelecione: 'Seleccione el instructor / entrenador',
    },
    servico: {
      singular: 'Clase / Entrenamiento',
      plural: 'Clases y Entrenamientos',
      genero: 'F',
      placeholderBusca: 'Buscar clase o modalidad...',
      placeholderNovo: 'Nombre de la clase / modalidad',
      placeholderSelecione: 'Seleccione la clase / modalidad',
    },
    agendamento: {
      singular: 'Clase',
      plural: 'Clases',
      btnNovo: 'Reservar Clase',
      modalTituloNovo: 'Reservar Nueva Clase',
      confirmacaoCancelamento: '¿Realmente desea cancelar esta reserva de clase?',
    },
  },
  [NichoEstabelecimentoEnum.PET_CARE]: {
    nichoId: NichoEstabelecimentoEnum.PET_CARE,
    nichoNome: 'Mascotas y Veterinaria',
    cliente: {
      singular: 'Tutor (Mascota)',
      plural: 'Tutores y Mascotas',
      genero: 'M',
      placeholderBusca: 'Buscar tutor o nombre de la mascota...',
      placeholderNovo: 'Nombre del tutor / mascota',
      placeholderSelecione: 'Seleccione el tutor / mascota',
    },
    profissional: {
      singular: 'Veterinario / Peluquero',
      plural: 'Veterinarios y Peluqueros',
      genero: 'M',
      placeholderBusca: 'Buscar veterinario o peluquero...',
      placeholderNovo: 'Nombre del veterinario / peluquero',
      placeholderSelecione: 'Seleccione el veterinario / peluquero',
    },
    servico: {
      singular: 'Baño y Corte / Consulta',
      plural: 'Baños y Consultas',
      genero: 'M',
      placeholderBusca: 'Buscar servicio de mascota...',
      placeholderNovo: 'Nombre del servicio',
      placeholderSelecione: 'Seleccione el servicio',
    },
    agendamento: {
      singular: 'Atención Pet',
      plural: 'Atenciones Pet',
      btnNovo: 'Nueva Cita Pet',
      modalTituloNovo: 'Agendar Cita Pet',
      confirmacaoCancelamento: '¿Realmente desea cancelar esta cita de mascota?',
    },
  },
  [NichoEstabelecimentoEnum.CONSULTORIA_SERVICOS]: {
    nichoId: NichoEstabelecimentoEnum.CONSULTORIA_SERVICOS,
    nichoNome: 'Consultoría y Servicios',
    cliente: {
      singular: 'Cliente',
      plural: 'Clientes',
      genero: 'M',
      placeholderBusca: 'Buscar cliente...',
      placeholderNovo: 'Nombre del cliente',
      placeholderSelecione: 'Seleccione el cliente',
    },
    profissional: {
      singular: 'Consultor / Abogado',
      plural: 'Consultores y Abogados',
      genero: 'M',
      placeholderBusca: 'Buscar consultor...',
      placeholderNovo: 'Nombre del consultor / abogado',
      placeholderSelecione: 'Seleccione el consultor / abogado',
    },
    servico: {
      singular: 'Consultoría / Reunión',
      plural: 'Consultorías y Reuniones',
      genero: 'F',
      placeholderBusca: 'Buscar tipo de consultoría...',
      placeholderNovo: 'Asunto / Tipo de consultoría',
      placeholderSelecione: 'Seleccione el tipo de consultoría',
    },
    agendamento: {
      singular: 'Reunión',
      plural: 'Reuniones',
      btnNovo: 'Agendar Reunión',
      modalTituloNovo: 'Agendar Nueva Reunión',
      confirmacaoCancelamento: '¿Realmente desea cancelar esta reunión?',
    },
  },
  [NichoEstabelecimentoEnum.ESTUDIO_ARTE]: {
    nichoId: NichoEstabelecimentoEnum.ESTUDIO_ARTE,
    nichoNome: 'Arte y Estudio',
    cliente: {
      singular: 'Cliente',
      plural: 'Clientes',
      genero: 'M',
      placeholderBusca: 'Buscar cliente...',
      placeholderNovo: 'Nombre del cliente',
      placeholderSelecione: 'Seleccione el cliente',
    },
    profissional: {
      singular: 'Artista / Tatuador',
      plural: 'Artistas y Tatuadores',
      genero: 'M',
      placeholderBusca: 'Buscar artista o tatuador...',
      placeholderNovo: 'Nombre del artista / tatuador',
      placeholderSelecione: 'Seleccione el artista / tatuador',
    },
    servico: {
      singular: 'Sesión / Ensayo',
      plural: 'Sesiones y Ensayos',
      genero: 'F',
      placeholderBusca: 'Buscar tipo de sesión...',
      placeholderNovo: 'Nombre de la sesión / ensayo',
      placeholderSelecione: 'Seleccione la sesión / ensayo',
    },
    agendamento: {
      singular: 'Sesión',
      plural: 'Sesiones',
      btnNovo: 'Agendar Sesión',
      modalTituloNovo: 'Agendar Nueva Sesión',
      confirmacaoCancelamento: '¿Realmente desea cancelar esta sesión?',
    },
  },
  [NichoEstabelecimentoEnum.SERVICOS_TECNICOS]: {
    nichoId: NichoEstabelecimentoEnum.SERVICOS_TECNICOS,
    nichoNome: 'Servicios Técnicos y Mantenimiento',
    cliente: {
      singular: 'Cliente',
      plural: 'Clientes',
      genero: 'M',
      placeholderBusca: 'Buscar cliente por nombre o móvil...',
      placeholderNovo: 'Nombre del cliente',
      placeholderSelecione: 'Seleccione el cliente',
    },
    profissional: {
      singular: 'Técnico',
      plural: 'Técnicos',
      genero: 'M',
      placeholderBusca: 'Buscar técnico...',
      placeholderNovo: 'Nombre del técnico',
      placeholderSelecione: 'Seleccione el técnico',
    },
    servico: {
      singular: 'Servicio',
      plural: 'Servicios',
      genero: 'M',
      placeholderBusca: 'Buscar servicio o tipo de visita...',
      placeholderNovo: 'Nombre del servicio (ej: pintura, instalación)',
      placeholderSelecione: 'Seleccione el servicio',
    },
    agendamento: {
      singular: 'Visita',
      plural: 'Visitas',
      btnNovo: 'Nueva Visita',
      modalTituloNovo: 'Agendar Visita',
      confirmacaoCancelamento: '¿Realmente desea cancelar esta visita?',
    },
  },
  [NichoEstabelecimentoEnum.INFORMATICA]: {
    nichoId: NichoEstabelecimentoEnum.INFORMATICA,
    nichoNome: 'Informática y Asistencia Técnica',
    cliente: {
      singular: 'Cliente',
      plural: 'Clientes',
      genero: 'M',
      placeholderBusca: 'Buscar cliente por nombre o móvil...',
      placeholderNovo: 'Nombre del cliente',
      placeholderSelecione: 'Seleccione el cliente',
    },
    profissional: {
      singular: 'Técnico',
      plural: 'Técnicos',
      genero: 'M',
      placeholderBusca: 'Buscar técnico...',
      placeholderNovo: 'Nombre del técnico',
      placeholderSelecione: 'Seleccione el técnico',
    },
    servico: {
      singular: 'Servicio / Reparación',
      plural: 'Servicios y Reparaciones',
      genero: 'M',
      placeholderBusca: 'Buscar servicio o reparación...',
      placeholderNovo: 'Nombre del servicio',
      placeholderSelecione: 'Seleccione el servicio',
    },
    agendamento: {
      singular: 'Atención',
      plural: 'Atenciones',
      btnNovo: 'Nueva Atención',
      modalTituloNovo: 'Agendar Atención',
      confirmacaoCancelamento: '¿Realmente desea cancelar esta atención?',
    },
  },
  [NichoEstabelecimentoEnum.AUTOMOTIVO]: {
    nichoId: NichoEstabelecimentoEnum.AUTOMOTIVO,
    nichoNome: 'Taller Automotriz',
    cliente: {
      singular: 'Cliente',
      plural: 'Clientes',
      genero: 'M',
      placeholderBusca: 'Buscar cliente por nombre o matrícula...',
      placeholderNovo: 'Nombre del cliente',
      placeholderSelecione: 'Seleccione el cliente',
    },
    profissional: {
      singular: 'Mecánico',
      plural: 'Mecánicos',
      genero: 'M',
      placeholderBusca: 'Buscar mecánico...',
      placeholderNovo: 'Nombre del mecánico',
      placeholderSelecione: 'Seleccione el mecánico',
    },
    servico: {
      singular: 'Servicio',
      plural: 'Servicios',
      genero: 'M',
      placeholderBusca: 'Buscar servicio (revisión, alineación...)',
      placeholderNovo: 'Nombre del servicio',
      placeholderSelecione: 'Seleccione el servicio',
    },
    agendamento: {
      singular: 'Orden de Servicio',
      plural: 'Órdenes de Servicio',
      btnNovo: 'Nueva OS',
      modalTituloNovo: 'Nueva Orden de Servicio',
      confirmacaoCancelamento: '¿Realmente desea cancelar esta orden de servicio?',
    },
  },
};

/** Dicionário em Francês (fr-FR) */
export const NICHO_TERMOS_FR: Record<NichoEstabelecimentoEnum, INichoTermos> = {
  [NichoEstabelecimentoEnum.BELEZA_ESTETICA]: {
    nichoId: NichoEstabelecimentoEnum.BELEZA_ESTETICA,
    nichoNome: 'Beauté et esthétique',
    cliente: {
      singular: 'Client',
      plural: 'Clients',
      genero: 'M',
      placeholderBusca: 'Rechercher un client par nom ou téléphone...',
      placeholderNovo: 'Nom du client',
      placeholderSelecione: 'Sélectionnez le client',
    },
    profissional: {
      singular: 'Professionnel',
      plural: 'Professionnels',
      genero: 'M',
      placeholderBusca: 'Rechercher un professionnel...',
      placeholderNovo: 'Nom du professionnel',
      placeholderSelecione: 'Sélectionnez le professionnel',
    },
    servico: {
      singular: 'Prestation',
      plural: 'Prestations',
      genero: 'F',
      placeholderBusca: 'Rechercher une prestation...',
      placeholderNovo: 'Nom de la prestation',
      placeholderSelecione: 'Sélectionnez la prestation',
    },
    agendamento: {
      singular: 'Rendez-vous',
      plural: 'Rendez-vous',
      btnNovo: 'Nouveau rendez-vous',
      modalTituloNovo: 'Nouveau rendez-vous',
      confirmacaoCancelamento: 'Voulez-vous vraiment annuler ce rendez-vous ?',
    },
  },
  [NichoEstabelecimentoEnum.SAUDE_BEM_ESTAR]: {
    nichoId: NichoEstabelecimentoEnum.SAUDE_BEM_ESTAR,
    nichoNome: 'Santé et bien-être',
    cliente: {
      singular: 'Patient',
      plural: 'Patients',
      genero: 'M',
      placeholderBusca: 'Rechercher un patient par nom ou document...',
      placeholderNovo: 'Nom du patient',
      placeholderSelecione: 'Sélectionnez le patient',
    },
    profissional: {
      singular: 'Spécialiste',
      plural: 'Spécialistes',
      genero: 'M',
      placeholderBusca: 'Rechercher un médecin ou un spécialiste...',
      placeholderNovo: 'Nom du médecin / spécialiste',
      placeholderSelecione: 'Sélectionnez le médecin / spécialiste',
    },
    servico: {
      singular: 'Consultation / Acte',
      plural: 'Consultations et actes',
      genero: 'F',
      placeholderBusca: 'Rechercher une consultation ou un acte...',
      placeholderNovo: 'Nom de la consultation / de l’acte',
      placeholderSelecione: 'Sélectionnez la consultation / l’acte',
    },
    agendamento: {
      singular: 'Consultation',
      plural: 'Consultations',
      btnNovo: 'Nouvelle consultation',
      modalTituloNovo: 'Planifier une consultation',
      confirmacaoCancelamento: 'Voulez-vous vraiment annuler cette consultation ?',
    },
  },
  [NichoEstabelecimentoEnum.FITNESS_ESPORTES]: {
    nichoId: NichoEstabelecimentoEnum.FITNESS_ESPORTES,
    nichoNome: 'Fitness et studios',
    cliente: {
      singular: 'Élève',
      plural: 'Élèves',
      genero: 'M',
      placeholderBusca: 'Rechercher un élève par nom...',
      placeholderNovo: 'Nom de l’élève',
      placeholderSelecione: 'Sélectionnez l’élève',
    },
    profissional: {
      singular: 'Instructeur / Coach',
      plural: 'Instructeurs et coachs',
      genero: 'M',
      placeholderBusca: 'Rechercher un instructeur...',
      placeholderNovo: 'Nom de l’instructeur / du coach',
      placeholderSelecione: 'Sélectionnez l’instructeur / le coach',
    },
    servico: {
      singular: 'Cours / Séance',
      plural: 'Cours et séances',
      genero: 'M',
      placeholderBusca: 'Rechercher un cours ou une modalité...',
      placeholderNovo: 'Nom du cours / de la séance',
      placeholderSelecione: 'Sélectionnez le cours / la séance',
    },
    agendamento: {
      singular: 'Cours',
      plural: 'Cours',
      btnNovo: 'Réserver un cours',
      modalTituloNovo: 'Réserver un nouveau cours',
      confirmacaoCancelamento: 'Voulez-vous vraiment annuler cette réservation de cours ?',
    },
  },
  [NichoEstabelecimentoEnum.PET_CARE]: {
    nichoId: NichoEstabelecimentoEnum.PET_CARE,
    nichoNome: 'Animaux et vétérinaire',
    cliente: {
      singular: 'Propriétaire',
      plural: 'Propriétaires',
      genero: 'M',
      placeholderBusca: 'Rechercher le propriétaire ou le nom de l’animal...',
      placeholderNovo: 'Nom du propriétaire / de l’animal',
      placeholderSelecione: 'Sélectionnez le propriétaire / l’animal',
    },
    profissional: {
      singular: 'Vétérinaire / Toiletteur',
      plural: 'Vétérinaires et toiletteurs',
      genero: 'M',
      placeholderBusca: 'Rechercher un vétérinaire ou un toiletteur...',
      placeholderNovo: 'Nom du vétérinaire / toiletteur',
      placeholderSelecione: 'Sélectionnez le vétérinaire / toiletteur',
    },
    servico: {
      singular: 'Toilettage / Consultation',
      plural: 'Toilettages et consultations',
      genero: 'M',
      placeholderBusca: 'Rechercher une prestation animalière...',
      placeholderNovo: 'Nom de la prestation',
      placeholderSelecione: 'Sélectionnez la prestation',
    },
    agendamento: {
      singular: 'Rendez-vous animal',
      plural: 'Rendez-vous animaux',
      btnNovo: 'Nouveau rendez-vous animal',
      modalTituloNovo: 'Planifier un rendez-vous animal',
      confirmacaoCancelamento: 'Voulez-vous vraiment annuler ce rendez-vous animal ?',
    },
  },
  [NichoEstabelecimentoEnum.CONSULTORIA_SERVICOS]: {
    nichoId: NichoEstabelecimentoEnum.CONSULTORIA_SERVICOS,
    nichoNome: 'Conseil et services',
    cliente: {
      singular: 'Client',
      plural: 'Clients',
      genero: 'M',
      placeholderBusca: 'Rechercher un client...',
      placeholderNovo: 'Nom du client',
      placeholderSelecione: 'Sélectionnez le client',
    },
    profissional: {
      singular: 'Consultant / Avocat',
      plural: 'Consultants et avocats',
      genero: 'M',
      placeholderBusca: 'Rechercher un consultant...',
      placeholderNovo: 'Nom du consultant / avocat',
      placeholderSelecione: 'Sélectionnez le consultant / avocat',
    },
    servico: {
      singular: 'Conseil / Réunion',
      plural: 'Conseils et réunions',
      genero: 'M',
      placeholderBusca: 'Rechercher un type de conseil...',
      placeholderNovo: 'Objet / type de conseil',
      placeholderSelecione: 'Sélectionnez le type de conseil',
    },
    agendamento: {
      singular: 'Réunion',
      plural: 'Réunions',
      btnNovo: 'Planifier une réunion',
      modalTituloNovo: 'Planifier une nouvelle réunion',
      confirmacaoCancelamento: 'Voulez-vous vraiment annuler cette réunion ?',
    },
  },
  [NichoEstabelecimentoEnum.ESTUDIO_ARTE]: {
    nichoId: NichoEstabelecimentoEnum.ESTUDIO_ARTE,
    nichoNome: 'Art et studio',
    cliente: {
      singular: 'Client',
      plural: 'Clients',
      genero: 'M',
      placeholderBusca: 'Rechercher un client...',
      placeholderNovo: 'Nom du client',
      placeholderSelecione: 'Sélectionnez le client',
    },
    profissional: {
      singular: 'Artiste / Tatoueur',
      plural: 'Artistes et tatoueurs',
      genero: 'M',
      placeholderBusca: 'Rechercher un artiste ou un tatoueur...',
      placeholderNovo: 'Nom de l’artiste / tatoueur',
      placeholderSelecione: 'Sélectionnez l’artiste / tatoueur',
    },
    servico: {
      singular: 'Séance / Shooting',
      plural: 'Séances et shootings',
      genero: 'F',
      placeholderBusca: 'Rechercher un type de séance...',
      placeholderNovo: 'Nom de la séance / du shooting',
      placeholderSelecione: 'Sélectionnez la séance / le shooting',
    },
    agendamento: {
      singular: 'Séance',
      plural: 'Séances',
      btnNovo: 'Planifier une séance',
      modalTituloNovo: 'Planifier une nouvelle séance',
      confirmacaoCancelamento: 'Voulez-vous vraiment annuler cette séance ?',
    },
  },
  [NichoEstabelecimentoEnum.SERVICOS_TECNICOS]: {
    nichoId: NichoEstabelecimentoEnum.SERVICOS_TECNICOS,
    nichoNome: 'Services techniques et maintenance',
    cliente: {
      singular: 'Client',
      plural: 'Clients',
      genero: 'M',
      placeholderBusca: 'Rechercher un client par nom ou téléphone...',
      placeholderNovo: 'Nom du client',
      placeholderSelecione: 'Sélectionnez le client',
    },
    profissional: {
      singular: 'Technicien',
      plural: 'Techniciens',
      genero: 'M',
      placeholderBusca: 'Rechercher un technicien...',
      placeholderNovo: 'Nom du technicien',
      placeholderSelecione: 'Sélectionnez le technicien',
    },
    servico: {
      singular: 'Prestation',
      plural: 'Prestations',
      genero: 'F',
      placeholderBusca: 'Rechercher une prestation ou un type de visite...',
      placeholderNovo: 'Nom de la prestation (ex. : peinture, installation)',
      placeholderSelecione: 'Sélectionnez la prestation',
    },
    agendamento: {
      singular: 'Visite',
      plural: 'Visites',
      btnNovo: 'Nouvelle visite',
      modalTituloNovo: 'Planifier une visite',
      confirmacaoCancelamento: 'Voulez-vous vraiment annuler cette visite ?',
    },
  },
  [NichoEstabelecimentoEnum.INFORMATICA]: {
    nichoId: NichoEstabelecimentoEnum.INFORMATICA,
    nichoNome: 'Informatique et assistance technique',
    cliente: {
      singular: 'Client',
      plural: 'Clients',
      genero: 'M',
      placeholderBusca: 'Rechercher un client par nom ou téléphone...',
      placeholderNovo: 'Nom du client',
      placeholderSelecione: 'Sélectionnez le client',
    },
    profissional: {
      singular: 'Technicien',
      plural: 'Techniciens',
      genero: 'M',
      placeholderBusca: 'Rechercher un technicien...',
      placeholderNovo: 'Nom du technicien',
      placeholderSelecione: 'Sélectionnez le technicien',
    },
    servico: {
      singular: 'Prestation / Réparation',
      plural: 'Prestations et réparations',
      genero: 'F',
      placeholderBusca: 'Rechercher une prestation ou une réparation...',
      placeholderNovo: 'Nom de la prestation',
      placeholderSelecione: 'Sélectionnez la prestation',
    },
    agendamento: {
      singular: 'Intervention',
      plural: 'Interventions',
      btnNovo: 'Nouvelle intervention',
      modalTituloNovo: 'Planifier une intervention',
      confirmacaoCancelamento: 'Voulez-vous vraiment annuler cette intervention ?',
    },
  },
  [NichoEstabelecimentoEnum.AUTOMOTIVO]: {
    nichoId: NichoEstabelecimentoEnum.AUTOMOTIVO,
    nichoNome: 'Atelier automobile',
    cliente: {
      singular: 'Client',
      plural: 'Clients',
      genero: 'M',
      placeholderBusca: 'Rechercher un client par nom ou plaque...',
      placeholderNovo: 'Nom du client',
      placeholderSelecione: 'Sélectionnez le client',
    },
    profissional: {
      singular: 'Mécanicien',
      plural: 'Mécaniciens',
      genero: 'M',
      placeholderBusca: 'Rechercher un mécanicien...',
      placeholderNovo: 'Nom du mécanicien',
      placeholderSelecione: 'Sélectionnez le mécanicien',
    },
    servico: {
      singular: 'Prestation',
      plural: 'Prestations',
      genero: 'F',
      placeholderBusca: 'Rechercher une prestation (révision, alignement...)',
      placeholderNovo: 'Nom de la prestation',
      placeholderSelecione: 'Sélectionnez la prestation',
    },
    agendamento: {
      singular: 'Ordre de service',
      plural: 'Ordres de service',
      btnNovo: 'Nouvel OS',
      modalTituloNovo: 'Nouvel ordre de service',
      confirmacaoCancelamento: 'Voulez-vous vraiment annuler cet ordre de service ?',
    },
  },
};

/**
 * Mapa central multilingue indexado por código de idioma (pt, en, es, fr).
 */
export const NICHO_TERMOS_MULTILANG_MAP: Record<string, Record<NichoEstabelecimentoEnum, INichoTermos>> = {
  pt: NICHO_TERMOS_PT,
  en: NICHO_TERMOS_EN,
  es: NICHO_TERMOS_ES,
  fr: NICHO_TERMOS_FR,
};

/**
 * Exportação de retrocompatibilidade:
 * Permite que códigos legados continuem importando `NICHO_TERMOS_MAP` sem quebrar.
 */
export const NICHO_TERMOS_MAP: Record<NichoEstabelecimentoEnum, INichoTermos> = NICHO_TERMOS_PT;
